import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { useResponsiveSize } from '@bingads-webui-react/with-responsive-size';
import { Constants } from '@bingads-webui-theme-2018/theme-fluent';
import { useFormService, FORM_STATES } from '@bingads-webui-react/form';
import { StepHeader } from '@bingads-webui-campaign-react/pmax-common';
import { useIsEstimationApiSupportedLocale } from '@bingads-webui-campaign-react/pmax-lite-data';
import { isSDK } from '@bingads-webui-campaign-react/sdk-utils';

import { CollapsibleLocation } from './collapsible-location';
import { CollapsibleAudienceSignal } from './collapsible-audience-signal';
import { CollapsibleSearchThemes } from './collapsible-search-themes';
import { TargetingEstimation } from './targeting-estimation';
import { getTargetingStepStyle } from '../styles/targeting-step-style';

export const TargetingStep = ({
  data,
  onDataChange,
  hideStepInfo,
  hideEstimationTile,
}) => {
  const isAudienceSignalEnabled = !isSDK();
  const isSearchThemesEnabled = !isSDK();

  const classes = useDefaultStyles(getTargetingStepStyle);
  const displayMode = useResponsiveSize(Constants.ResponsiveSizeBreakpoints);
  const { state } = useFormService();

  const isLoading = state.matches(FORM_STATES.LOADING);
  const showEstimationTile = useIsEstimationApiSupportedLocale() && !hideEstimationTile;

  return (
    <div className={classNames('pmax-targeting-step-shell', classes.stepShell, classes[`stepShell-${displayMode}`])}>
      {!hideStepInfo && <StepHeader
        title={_TL_('Add location targets')}
        description={_TL_('Tell us where customers must be located to see your ads.')}
      />}
      <div className={classNames('targets-and-estimation', classes.mainContent, classes[`mainContent-${displayMode}`])}>
        <div className={classNames('targets-part', classes.targetsPart, classes[`targetsPart-${displayMode}`])}>
          <CollapsibleLocation
            classes={classes}
            isLoading={isLoading}
            data={data}
            onDataChange={onDataChange}
          />
          {
            isAudienceSignalEnabled && (
              <CollapsibleAudienceSignal
                classes={classes}
                isLoading={isLoading}
                data={data}
                onDataChange={onDataChange}
              />
            )
          }
          {
            (isSearchThemesEnabled &&
              <CollapsibleSearchThemes
                data={data}
                onDataChange={onDataChange}
                isLoading={isLoading}
              />
            )
          }
        </div>
        {showEstimationTile &&
          <div className={classNames('estimation-part', classes.estimationPart, classes[`estimationPart-${displayMode}`])}>
            <TargetingEstimation data={data} />
          </div>
        }
      </div>
    </div>
  );
};

TargetingStep.propTypes = {
  data: PropTypes.shape({}).isRequired,
  onDataChange: PropTypes.func.isRequired,
  hideStepInfo: PropTypes.bool,
  hideEstimationTile: PropTypes.bool,
};

TargetingStep.defaultProps = {
  hideStepInfo: false,
  hideEstimationTile: false,
};
